import { useState, useEffect } from "react";
import { ListLayout } from "../../../layouts";
import { DataGrid, Dialog } from "../../../components";
import {
  notification,
  ProdutosService,
  FamiliaProdutosService,
} from "../../../services";
import { responseErros } from "../../../utils";
import { PermisoesHelper } from "../../../helpers";
import AddFamiliaProdutos from "../addFamilias/addFamilias.view";

const ListFamiliaProdutosView = () => {
  const familiaProdutosService = new FamiliaProdutosService();
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("grupo-produtos-visualizar");
  const produtosService = new ProdutosService();
  const [loading, setLoading] = useState(false);
  const [familiaProdutosId, setFamiliaProdutosId] = useState(null);
  const [produtosList, setProdutosList] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [familiasProdutos, setFamiliasProdutos] = useState([]);
  const [rowCount, setRowCount] = useState(0);

  const colunas = [
    {
      field: "codigo",
      headerName: "Código",
      flex: 100,
    },
    {
      field: "descricao",
      headerName: "Descrição",
      flex: 700,
      filtrar: true,
    },
  ];

  useEffect(() => {
    buscaFamiliasProdutos();
    buscarProdutos();
  }, []);

  const buscaFamiliasProdutos = async (query) => {
    const filter = {
      ...query,
    };
    setLoading(true);
    const result = await familiaProdutosService.getAll(filter);
    if (!result.isAxiosError) {
      setRowCount(result.data.count);
      setFamiliasProdutos(result.data.rows);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const buscarProdutos = async (filtro) => {
    const filtros = {
      ...filtro,
    };
    setLoading(true);
    const res = await produtosService.getAllProdutosSimples(filtros);
    if (!res.isAxiosError) {
      setProdutosList(res.data.rows);
    } else {
      responseErros(res);
    }
    setLoading(false);
  };

  const handleOpenDialog = (id) => {
    setFamiliaProdutosId(id);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setFamiliaProdutosId(null);
    setOpenDialog(false);
  };

  const sendServerDatagrid = (props) => {
    buscaFamiliasProdutos(props.filtros);
  };

  const handleDeleteFamiliaProduto = async (id) => {
    const produto = produtosList.some((item) => item.familiaProdutoId === id);
    const retornoAlerta = await notification.confirmacao(
      "Excluir!",
      `Tem certeza que deseja excluir essa família de produto?`,
    );
    if (retornoAlerta.isConfirmed) {
      if (produto) {
        notification.alertaGenericos(
          "Não se pode remover família inserido em outros cadastros",
        );
        return;
      }
      setLoading(true);
      const result = await familiaProdutosService.deletar(id);
      if (!result.isAxiosError) {
        buscaFamiliasProdutos();
        notification.deletadoSucesso();
      } else {
        setLoading(false);
        responseErros(result);
      }
    }
  };

  return (
    <ListLayout
      title="Famílias de Produtos"
      loading={loading}
      onClickCadastrar={handleOpenDialog}
      permissaoButton={permissoesHelper.temPermisao("grupo-produtos-cadastrar")}
    >
      <DataGrid
        rows={familiasProdutos}
        columns={colunas}
        onClickEdit={handleOpenDialog}
        onClickDelete={handleDeleteFamiliaProduto}
        visualizarShow={permissoesHelper.temPermisao(
          "grupo-produtos-visualizar",
        )}
        editShow={permissoesHelper.temPermisao("grupo-produtos-editar")}
        deleteShow={permissoesHelper.temPermisao("grupo-produtos-excluir")}
        paginationMode={"server"}
        sendServer={(props) => sendServerDatagrid(props)}
        rowCount={rowCount}
        hideFiltroAvancado
      />
      <Dialog
        disableEscapeKeyDown
        fullWidth
        maxWidth="md"
        open={openDialog}
        aria-labelledby="form-dialog-title"
      >
        <AddFamiliaProdutos
          id={familiaProdutosId}
          handleCloseDialog={handleCloseDialog}
          openDialog={openDialog}
          buscaFamiliasProdutos={buscaFamiliasProdutos}
        />
      </Dialog>
    </ListLayout>
  );
};

export default ListFamiliaProdutosView;
